<template>
    <div class="cabin-details">
        <div v-if="showAll || (hasCabin && details?.customData.class === 'available')" class="details">
            <div class="color available"></div>
            <span v-if="showAll">Many cabins of this type available.</span>
            <span v-else>{{ cabins }} cabins of this type available.</span>
        </div>
        <div v-if="showAll || (hasCabin && details?.customData.class === 'almost-full')" class="details">
            <div class="color almost-full"></div>
            <span v-if="showAll">Few cabins of this type available.</span>
            <span v-else>{{ cabins }} cabins of this type available.</span>
        </div>
        <div v-if="showAll || (hasCabin && details?.customData.class === 'no-cabin')" class="details">
            <div class="color no-cabin"></div>
            <span>No cabins of this type available.</span>
        </div>
    </div>
    <div class="vehicle-details">
        <div v-if="showAll || (hasVehicle && fitsVehicle)" class="details">
            <div class="icon">
                <img src="@/assets/car-available.svg" class="icon__svg" />
            </div>
            <span>Vehicle space available.</span>
        </div>
        <div v-if="showAll || (hasVehicle && !fitsVehicle)" class="details">
            <div class="icon">
                <img src="@/assets/icons/Cardeck-is-full.svg" class="icon__svg" />
            </div>
            <span>No vehicle space available.</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Attribute } from "../models/AvailabilityCalendarTypes";
import { computed, defineProps } from "vue";

interface Props {
    details?: Attribute;
    hasVehicle?: boolean;
    hasCabin?: boolean;
    showAll?: boolean;
}

const props = defineProps<Props>();

const cabins = computed(() => props.details?.customData.cabins ?? 0);

const fitsVehicle = computed(() => props.details?.customData.fitsVehicle);
</script>

<style scoped lang="scss">
.details {
    font-size: 0.75rem;
}
</style>
